import { render, staticRenderFns } from "./CampaignROI.vue?vue&type=template&id=2d27880b&scoped=true"
import script from "./CampaignROI.vue?vue&type=script&lang=js"
export * from "./CampaignROI.vue?vue&type=script&lang=js"
import style0 from "./CampaignROI.vue?vue&type=style&index=0&id=2d27880b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d27880b",
  null
  
)

export default component.exports